var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.158,
    height: 129,
    viewBox: "0 0 115.158 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2555",
    "data-name": "Grupo 2555",
    transform: "translate(-146.842 -143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fingerprint-black-48dp",
    transform: "translate(146.842 143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_38",
    "data-name": "Trazado 38",
    d: "M0,0H57V61H0Z",
    transform: "translate(23.663 27.628)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39",
    "data-name": "Trazado 39",
    d: "M88.862,16.358a2.687,2.687,0,0,1-1.333-.349c-11.129-5.755-20.752-8.2-32.287-8.2a66.169,66.169,0,0,0-32.287,8.2,2.912,2.912,0,0,1-2.782-5.115A72.623,72.623,0,0,1,55.242,2C67.589,2,78.37,4.732,90.2,10.836a2.85,2.85,0,0,1,1.217,3.895,2.84,2.84,0,0,1-2.55,1.628ZM5.913,46.875a3.014,3.014,0,0,1-1.681-.523,2.9,2.9,0,0,1-.7-4.069A59.981,59.981,0,0,1,25.274,23.275a66.744,66.744,0,0,1,59.762-.058,60.208,60.208,0,0,1,21.737,18.892,2.914,2.914,0,1,1-4.753,3.371A54.462,54.462,0,0,0,82.37,28.39a60.927,60.927,0,0,0-54.488.058A55.036,55.036,0,0,0,8.174,45.654a2.525,2.525,0,0,1-2.261,1.221Zm36.228,70.161a2.715,2.715,0,0,1-2.029-.872,58.745,58.745,0,0,1-11.651-15.346,51.717,51.717,0,0,1-6.086-25.228c0-17.264,14.723-31.331,32.808-31.331S87.993,58.326,87.993,75.591a2.9,2.9,0,1,1-5.8,0c0-14.067-12.115-25.518-27.012-25.518S28.172,61.524,28.172,75.591A45.641,45.641,0,0,0,33.563,97.97a55,55,0,0,0,10.724,14.067,2.991,2.991,0,0,1,0,4.127A3.175,3.175,0,0,1,42.142,117.036ZM83.7,106.282A30.942,30.942,0,0,1,51.938,75.591a2.9,2.9,0,1,1,5.8,0A25.02,25.02,0,0,0,68.98,96.284,25.364,25.364,0,0,0,83.7,100.411a38.2,38.2,0,0,0,6.028-.581,2.919,2.919,0,0,1,.985,5.755A39.476,39.476,0,0,1,83.7,106.282ZM72.052,118.257a3.383,3.383,0,0,1-.754-.116c-9.217-2.558-15.245-5.987-21.563-12.207A42.474,42.474,0,0,1,37.157,75.591c0-9.417,8-17.09,17.853-17.09s17.853,7.673,17.853,17.09c0,6.22,5.391,11.277,12.057,11.277S96.977,81.81,96.977,75.591c0-21.914-18.839-39.7-42.025-39.7-16.462,0-31.533,9.184-38.315,23.426a37.483,37.483,0,0,0-3.42,16.276A57.911,57.911,0,0,0,17.1,96.575a2.839,2.839,0,0,1-1.681,3.72,2.873,2.873,0,0,1-3.71-1.686A64.92,64.92,0,0,1,7.478,75.591,43.775,43.775,0,0,1,11.42,56.757C19.13,40.539,36.229,30.018,54.952,30.018c26.374,0,47.822,20.4,47.822,45.515,0,9.417-8,17.09-17.853,17.09s-17.853-7.673-17.853-17.09c0-6.22-5.391-11.277-12.057-11.277S42.953,69.313,42.953,75.532a36.658,36.658,0,0,0,10.84,26.216c5.507,5.464,10.782,8.487,18.955,10.754a2.886,2.886,0,0,1,2.029,3.546,2.83,2.83,0,0,1-2.724,2.209Z",
    transform: "translate(-2.997 -2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2554",
    "data-name": "Grupo 2554",
    transform: "translate(-33 -532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2009",
    "data-name": "Grupo 2009",
    transform: "translate(258 767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1078",
    "data-name": "Grupo 1078",
    transform: "translate(0 37) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4433",
    "data-name": "Trazado 4433",
    d: "M18.5,0A18.5,18.5,0,1,1,0,18.5,18.5,18.5,0,0,1,18.5,0Z",
    fill: "#28a745"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ico_record",
    "data-name": "ico/record",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4276",
    "data-name": "Trazado 4276",
    d: "M0,0H31.714V31.714H0Z",
    fill: "none",
    opacity: 0.24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "check_black_24dp",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7931",
    "data-name": "Trazado 7931",
    d: "M0,0H21.8V21.8H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7932",
    "data-name": "Trazado 7932",
    d: "M8.993,17.272l-4.165-4.6L3.41,14.224,8.993,20.4,20.978,7.147,19.57,5.59Z",
    transform: "translate(-1.157 -1.897)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintOk);
export default __webpack_public_path__ + "static/media/printOk.47d6a2b85b716892c5b7a00bba287149.svg";
export { ForwardRef as ReactComponent };